<template>
	<div>
		<h2>{{ $t('tiers.menu_identifications') }}</h2>

		<p>{{ $t('tiers.identification.explication') }}</p>

		<div class="box">
			<CustomTable
				ref="table"
				id_table="tiers_identifications"
				:items="identifications"
				:busy.sync="table_busy"
				primaryKey="tiersident_id"
			/>
		</div>

		<IdentificationReassign
			ref="reassign"
			:tiers_id="parseInt(tiers_id)"
			@submit="reload"
		/>
	</div>
</template>

<script type="text/javascript">
	import Tiers from "@/mixins/Tiers.js"
	import Tools from "GroomyRoot/mixins/Tools.js"
	import Navigation from "GroomyRoot/mixins/Navigation.js"

	export default {
		name: "TiersIdentificationList",
		mixins: [Tiers, Tools, Navigation],
		props: ['tiers_id'],
		data() {
			return {
				identifications: [],
				table_busy: true,
				events_tab: {
					'TableAction::goToReassignTiersIdentification': (identification) => {
						this.$refs.reassign.open(identification)
					}
				}
			}
		},
		mounted() {
			this.init_component()
		},
		methods: {
			/**
			 * Charge les identifiants d'entreprise rattachés au tiers.
			 */
			async init_component() {
				this.table_busy = true
				const res = await this.loadTiersIdentifications(this.tiers_id)
				this.identifications = (Array.isArray(res) ? res : []).map(identification => ({
					...identification,
					tiersident_type_label: this.getTrad('tiers.identification.type_' + identification.tiersident_type)
				}))
				this.table_busy = false
			},
			reload() {
				if(this.$refs.table && typeof this.$refs.table.unselectAll === 'function') {
					this.$refs.table.unselectAll()
				}
				this.init_component()
			}
		},
		components: {
			CustomTable: () => import('GroomyRoot/components/Table/CustomTable'),
			IdentificationReassign: () => import('@/components/Tiers/IdentificationReassign')
		}
	}
</script>
